import { createContext } from "react";

/**
 * 上の帯 (LgShell の header) の中のパンくずの置き場。LgShell が渡す。
 * slot は置き場の要素 (描いたあとに入る)。hidden は帯が出ていない画面 (縦に読み進める頁) で、そのときは頁の頭に置く。
 * 外枠の外 (見本、クラウドエディターの帯) では null で、パンくずは呼んだ場所にそのまま出る
 */
export type LgCrumbSlot = { slot: HTMLElement | null; hidden: boolean };
export const LgCrumbSlotContext = createContext<LgCrumbSlot | null>(null);

/**
 * 学習目次を開く釦を、上の帯のパンくずの左に出す口。学習目次のある頁 (学習パスの項目の頁) だけが、開いている間 useLgHeaderToc で登録する。
 * 引き出しの中身と開閉の状態は頁が持ち、外枠は釦を描いて onToggle を呼ぶだけ (open は aria-expanded に出す)。
 * 登録した頁を離れると外れ、釦は消えてパンくずが左に詰まる
 */
export type LgHeaderToc = { open: boolean; onToggle: () => void };
export type LgHeaderTocRegistry = { toc: LgHeaderToc | null; setToc: (toc: LgHeaderToc | null) => void };
export const LgHeaderTocContext = createContext<LgHeaderTocRegistry | null>(null);
